import React, { useEffect, useState } from 'react'
import "./main.css"
import Visualization from '../../ui/Visualization/Visualization'
import Content from '../../ui/Content/Content'
import Categories from '../../ui/Categories/Categories'
import { PlanetData, PlanetName } from '../../App'

export type CategoryType = "overview" | "geology" | "structure"

const Main = ({currentPlanetData, currentPlanet}:{currentPlanetData: PlanetData[] | null, currentPlanet:PlanetName}) => {
  const [selectedCategory, setSelectedCategory] = useState<CategoryType>("overview");
  const informations = currentPlanetData && currentPlanetData[0][selectedCategory]

  const onCategoryChange = (category:CategoryType):void => {
    setSelectedCategory(category)
  }

  return informations &&  (
    <main id='main'>
       <Visualization selectedCategory={selectedCategory} currentPlanet={currentPlanet}/>
       <Content name={currentPlanet} informations={informations} />
       <Categories selectedCategory={selectedCategory} onCategoryChange={onCategoryChange}/> 
    </main>
  );
}
export default Main
